/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「成功的按钮：边角是圆的有背景颜色的按钮」
 */
<template>
  <div class="cRoundButton">
    <p
      class="buttonRound"
      :class="disabled ? 'disableds' : ''"
      @click="clickbtn"
    >
      {{ text }}
    </p>
  </div>
</template>


<script>
export default {
  props: ['text', 'disabled'],
  methods: {
    clickbtn() {
      if (!this.disabled) {
        this.$emit('clickbtn');
      }
    }
  }
};
</script>

<style lang="less"  scoped>
.cRoundButton {
  width: 100%;
  cursor: pointer;
  .buttonRound {
    width: 100%;
    height: 0.5rem;
    background: #00a4b0;
    opacity: 1;
    border-radius: 25px;
    font-size: 0.18rem;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 0.5rem;
    cursor: pointer;
  }
  .buttonRound.disableds {
    background: #adadad;
    color: #ffffff;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button/cRoundButton.vue